import { combineReducers } from "redux";
import { ChargingDataReducers } from "./ChargingDataStore/chargingDataReducer";
import { ChargingStationReducers } from "./ChargingStationStore/chargingStationReducer";
import { BookingTableReducers } from "./BookingTableStore/bookingTableReducer";

import { LoginReducer } from "./LoginStore/loginReducer";
import { CustomerTableReducer } from "./CustomerTableStore/customerTableReducer";
import { CustomerDetailReducer } from "./CustomerDetailStore/customerDetailReducer";


import { HelpSupportReducers } from "./HelpSupportStore/helpSupportReducer";
import { StationDetailReducers } from "./StationDetailStore/stationDetailReducer";
import { NotificationReducers } from "./NotificationStore/notificationReducer";
import { commonReducers } from "./common/commonReducers";
import { VendorReducers } from "./VendorStore/vendorReducer";
import { DashboardReducer } from "./DashboardStore/dashboardReducer";
import { ManufacturerTableReducer } from "./ManufacturerStore/ManufacturerReducer";
import { ConnectorsTableReducer } from "./ConnectorsTableStore/ConnectorsTableReducer";
import { AmenitiesTableReducer } from "./AmenitiesTableStore/AmenitiesTableReducer";
import { NetworkTableReducer } from "./ChargingNetworkStore/NetworkTableReducer";
import { AdminTableReducer } from "./AdminVendorStore/AdminTableReducer";
import { ConfigTableReducer } from "./VendorConfigStore/ConfigTableReducer";
import { DetailsTableReducer } from "./ManufacturViewDetailStore/DetailsTableReducer";
import { CoupanCityReducer } from "./CoupanCitylistStore/CoupanCityReducer";
import { ChargingNetworkWiseReducer } from "./ChargingNetworkWiseStore/ChargingNetworkWiseReducer";
import { VendorDetailReducers } from "./VendorDetailsStore/VendorDetailReducer";
import {  GlobleConfigurationReducer } from "./Configuration/ConfigurationReducer";
import { FaqReducer } from "./FaqTableStore/FaqReducer";
import { LeadsDataReducers } from "./Leads/LeadsReducer";
import { vehicleDataReducer } from "./vehicles/VehicleReducer";
import { ConnectorDataReducer } from "./Connector/ConnectorReducer";
import { RequestDataReducer } from "./Request/RequestReducer";
import { NavigationDataReducer } from "./Navigation/NavigationReducer";
import { SearchHistoryDataReducer } from "./SearchHistory/SearchHistoryReducer";
import { CheckIncustomerReducer } from "./CheckIn/CheckInCustomerReducer";
import { FeedbackReducer } from "./Feedback/FeedbackReducer";
import { AddStationReducers } from "./AddStationStore/addStationReducer";
import { TripDetailDataReducer } from "./TripDtailsStore/TripDetailReducer";
// import { AddStationReducers } from "./AddStationStore/addStationReducer";

const rootReducers = combineReducers({
    
    chargingStation: ChargingStationReducers,
    bookingTable: BookingTableReducers,
    // AddStationReducers:AddStationReducers,
    chargingData: ChargingDataReducers,
    login:  LoginReducer,
    customerTable: CustomerTableReducer,
    personalDetail: CustomerDetailReducer,
    common: commonReducers,
    Vendors: VendorReducers,
    helpSupport: HelpSupportReducers,
    stationDetail: StationDetailReducers,
    notification: NotificationReducers,
    dashboard:DashboardReducer,
    manufacturer:ManufacturerTableReducer,
    connectors:ConnectorsTableReducer,
    amenitiestable:AmenitiesTableReducer,
    NetworkTable:NetworkTableReducer,
    AdminTable:AdminTableReducer,
    ConfigTable:ConfigTableReducer,
    DetailsTable:DetailsTableReducer,
    CoupanCity:CoupanCityReducer,
    ChargingNet:ChargingNetworkWiseReducer,
    Vendordetail:VendorDetailReducers,
    GlobleConfiguration:GlobleConfigurationReducer,
    Faq:FaqReducer,
    LeadsData:LeadsDataReducers,
    vehicleData:vehicleDataReducer,
    ConnectorData:ConnectorDataReducer,
    RequestData:RequestDataReducer,
    NavigationData:NavigationDataReducer,
    TripDetailData:TripDetailDataReducer,
    SearchHistoryData:SearchHistoryDataReducer,
    CheckIncustomerData:CheckIncustomerReducer,
    FeedbackReducerData:FeedbackReducer,
    AddStationReducers:AddStationReducers,
});
export default rootReducers;
